import type {
  UserAssignmentProgress,
  AssignmentDetailV3,
} from 'src/v3/manage/manage.slice'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import type { AssignmentProgressRow } from '../types'

dayjs.extend(utc)

/**
 * Transforms user progress data into flat rows for DataGrid display
 * Each row represents one user's progress in one course
 * Used by both "By Course" and "By User" tabs (only grouping differs)
 */
export function transformToProgressRows(
  userProgress: UserAssignmentProgress[],
  assignment: AssignmentDetailV3 | null,
): AssignmentProgressRow[] {
  if (!userProgress || !assignment) {
    return []
  }

  return userProgress
    .filter((user) => user.courseProgress && user.courseProgress.length > 0)
    .flatMap((user) =>
      user.courseProgress!.map((course) => ({
        id: `${user.userID}-${course.courseID}`,
        courseID: course.courseID,
        courseName: course.courseName,
        userID: user.userID,
        userName: `${user.userName} (${user.email})`,
        status: course.status === 'Completed' ? 'Completed' : 'Incomplete',
        completionDate: course.completionDate
          ? dayjs.utc(course.completionDate).local().format('MMM D, YYYY')
          : 'N/A',
      })),
    )
}
